export const FETCH_SYSTEM_ANALYTICS_REQUEST = 'FETCH_SYSTEM_ANALYTICS_REQUEST';
export const FETCH_SYSTEM_ANALYTICS_SUCCESS = 'FETCH_SYSTEM_ANALYTICS_SUCCESS';
export const FETCH_SYSTEM_ANALYTICS_FAILURE = 'FETCH_SYSTEM_ANALYTICS_FAILURE';

export const EXPORT_ANALYTICS_REQUEST = 'EXPORT_ANALYTICS_REQUEST';
export const EXPORT_ANALYTICS_SUCCESS = 'EXPORT_ANALYTICS_SUCCESS';
export const EXPORT_ANALYTICS_FAILURE = 'EXPORT_ANALYTICS_FAILURE';

export const REFRESH_ANALYTICS_REQUEST = 'REFRESH_ANALYTICS_REQUEST';